<template>
	<modal :exibir="exibir" titulo="Reprovação da Anuência" custom-actions max-width="400" @close="$emit('fechar')">
		<template #body>
			<div class="px-2 py-5">
				<label-personalizado nome-campo="Motivo Reprovação"></label-personalizado>
				<span>{{ justificativa }}</span>
			</div>
		</template>
	</modal>
</template>
<script>
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'

export default {
	name: 'modal-exibir-justificativa',
	components: { LabelPersonalizado },
	props: {
		justificativa: {
			type: String,
			default: '',
		},
		exibir: {
			type: Boolean,
		},
	},
}
</script>
